module.exports = __webpack_public_path__ + "media/application/images/2022/magazine1-bb02c56110d6b0bf99f928238d979d7e.png";